/*eslint-disable */
import React from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../../utils/imageHelper";



declare const window: any;

interface CategoriasComponentProps {
  maintanance: any;
}

const CategoriasComponent: React.FC<CategoriasComponentProps> = ({
  maintanance,
}) => {
  return (
    <div className="categorias-posventa-mantenimiento-container">
      <div className="cars-categorias-posventa-mantenimiento-container">
        {maintanance?.map((item: any) => (
          <div className="car" key={item?.id}>
            <img 
              className="vehicle" 
              src={buildCmsUrl(item?.media?.url)} 
              srcSet={getSrcSet(item?.media?.url || '')}
              sizes={getSizes('400px')}
              alt={item?.title || "Imagen del vehículo Hyundai"} 
            />

            
            {/* H3 - Título de la categoría */}
            <h3 className="title">{item?.title}</h3>
            
            {/* H4 - Subtítulo */}
            <h4 className="subtitle">{item?.text1}</h4>
            
            {/* H5 - Descripción */}
            <h5 className="description">{item?.text2}</h5>
            
            {/* BOTÓN SIN MODIFICAR */}
            <a target="_blank" rel="noopener noreferrer" href={item?.url_button} className="btnn">
              {item?.button_text}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoriasComponent;